export enum FeedbackType {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  SELF_CHECK = 'SELF_CHECK',
  INFORMATIONAL = 'INFORMATIONAL',
}
